import { NodeType } from '@amplify/amp-module';
import ButtonHandler from '../button-handler';

export default class QuestionHandler extends ButtonHandler {
  constructor(ctx) {
    super(ctx, NodeType.question);
  }

  handleButtonsDelay(node) {
    const delayTimer = setTimeout(() => {
      this.store.dispatch('chatbotStore/setDelayedState', {
        nodeId: node.id,
        delayed: false,
        delayedKey: 'delayedButtons',
      });
    }, (node.buttonsDelay || 0) * 1000);

    this.store.dispatch('chatbotStore/saveDelay', { nodeId: `${node.id}-buttons`, delayTimer });
  }

  async handleNode(node, options = {}) {
    if (!!node.delay) {
      this.unsubscribe = this.store.subscribe((mutation) => {
        const { type, payload } = mutation;

        if (type === 'chatbotStore/UPDATE_STACK_ITEM' && payload?.nodeId === node.id && payload?.delayed === false) {
          this.unsubscribe();
          this.handleButtonsDelay(node);
        }
      });
    } else {
      this.handleButtonsDelay(node);
    }

    return super.handleNode(node, { ...options });
  }
}
